export const APPLICATIONS_LOCALIZED_FIELDS = new Set(["brief", "categories", "description", "name", "releaseNotes"]);
export const APPLICATIONS_VERSIONS_SHARED_FIELDS = new Set(["brief", "description"]);
export const APPLICATIONS_TYPE_VERSIONS_EXCLUDED_FIELDS = {
    binary: new Set(),
    "remote html": new Set([
        "cpuRequirement",
        "memoryRequirement",
        "storageRequirement",
        "systemPermissions",
        "packageSize",
        "signature",
    ]),
    webapp: new Set([
        "cpuRequirement",
        "memoryRequirement",
        "storageRequirement",
        "systemPermissions",
        "packageSize",
        "signature",
    ]),
};
export const APPLICATIONS_EMPTY_ARRAY_DISPLAYED_FIELDS = new Set(["functionalRequirements"]);
export const APPLICATIONS_TYPE_BINARY = "binary";
export const APPLICATIONS_TYPE_HTML = "remote html";
export const APPLICATIONS_TYPE_WEBAPP = "webapp";
export const COMPONENT_FOR_FIELD_TYPE = {
    text: "SahInput",
    textObject: "FormTextObjectGroup",
    textObjectsList: "FormTextObjectsListGroup",
    longTextObject: "FormTextObjectGroup",
    list: "FormMultiCheckboxGroup",
    select: "FormSelectGroup",
    longText: "FormTextareaGroup",
    iconFormField: "IconFormField",
    imagePicker: "ImagePickerGroup",
};
export const EDIT_OPERATION_STORE = "store";
export const EDIT_OPERATION_UPDATE = "update";
export const MODAL_TYPE_ALERT = "alert";
export const MODAL_TYPE_CONFIRM = "confirm";
export const MODAL_TYPE_ERROR = "error";
export const VERSION_NUMBER_PATTERN = "G.R.C";
